import formatTime from '@anm/helpers/time/formatTime';

import { StreamBadge } from './types';

const getTime = (n: number) => {
  const [min, sec] = formatTime(n).split(':');

  return +min < 5 ? `${min} min ${sec} sec` : `${min} min`;
};

export const getGoingLiveBadge = (time: number) =>
  ({
    icon: 'images/streaming/live-red-ic.svg',
    variant: 'light-red',
    text: `Scheduled live in ${getTime(time)}`
  } as StreamBadge);
